module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Upload-folder-70a501fe91d45f2ba9817a115aa4ee4a.svg";